import React, { useState } from 'react';

import ButtonMic from './ButtonMic';
import ButtonCam from './ButtonCam';
import ButtonLeave from './ButtonLeave';
import ButtonShare from './ButtonShare';
import ScreenShared from './ScreenShared';
import AnimationVolume from './AnimationVolume';

import "./Buttons.css";

const ButtonsContent = () => {
    const [isScreenSharing, setIsScreenSharing] = useState(false);
    const [screenSharingStream, setScreenSharingStream] = useState(false);

    return (
        <div className='btn_content_container'>
            <ButtonMic />

            <ButtonCam />

            <ButtonLeave />

            <ButtonShare
                isScreenSharing={isScreenSharing}
                setIsScreenSharing={setIsScreenSharing}
                screenSharingStream={screenSharingStream}
                setScreenSharingStream={setScreenSharingStream}
            />

            <AnimationVolume />
            
            {isScreenSharing && (<ScreenShared stream={screenSharingStream} />)}
        </div>
    );
};

export default ButtonsContent;